<template>
  <v-expansion-panel v-show="node && node.canView" v-model="isOpen">
    <v-expansion-panel-header
      class="title-skill"
      :style="isActive ? activeStyle : ''"
      @click.stop.prevent="selectNode"
      :hide-actions="!hasExpandableChildren"
    >
        <div 
            class="custom-flex" 
            :class="{
                'interview-acordeon-head': showMarkList
            }"
        >
            <div class="interview-title">
                <span :class="textClass">{{ getTitleByType(node.type) }}</span>
                <h3>{{ node.title }}</h3>
                <p v-if="node.description">{{ node.description }}</p>
            </div>

            <!-- loader -->
            <div v-if="markFlag && markLoadingId === node.id">
                <div :class="circleClass">
                    <v-progress-circular indeterminate></v-progress-circular>
                </div>
            </div>

            <!-- Посмотреть только если canViewScore -->
            <div
                v-else
                v-show="node.viewerRights && node.viewerRights.canViewScore"
                :class="circleClass"
            >
                <span v-if="node.score == null">0</span>
                <span v-else>{{ node.score }}</span>
            </div>
        </div>

        <!-- Оценка только если canPostScore -->
        <v-footer v-show="showMarkList" class="mb-0 bg-none mark-block">
            <marks-list-second-variant
                :elemType="node.type"
                :score="node.score"
                :type="node.tag"
                @selectMark="onSelectMark"
                v-on:click.stop.native="onClickMark"
            />
        </v-footer>
    </v-expansion-panel-header>

    

    <v-expansion-panel-content v-if="hasExpandableChildren">
      <!-- children -->
      <v-expansion-panels multiple>
        <InterviewTreeNode
          v-for="child in filteredChildren"
          :key="child.id"
          :node="child"
          :activeId="activeId"
          :markLoadingId="markLoadingId"
          :markFlag="markFlag"
          :status="status"
          @selectNode="$emit('selectNode', $event)"
          @requestMark="$emit('requestMark', $event)"
          @selectMark="$emit('selectMark', $event)"
        />
      </v-expansion-panels>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import MarksListSecondVariant from "@/components/MarksListSecondVariant";

export default {
    name: "InterviewTreeNode",
    components: { MarksListSecondVariant },

    props: {
        node: Object,
        activeId: Number,
        markLoadingId: Number,
        markFlag: Boolean,
        status: String,
    },

    data() {
        return {
            isOpen: false
        };
    },

    computed: {
        isActive() {
            return this.node && this.node.id === this.activeId;
        },
        activeStyle() {
            return "background: #e8e8e8; border-radius: 0;";
        },
        circleClass() {
            var classes = ["mark-circle"];

            if (!this.hasExpandableChildren) {
                classes.push("mr-41");
            }

            return classes.join(" ");
        },
        textClass() {
            if (!this.node) return "mark-circle";
            return "color-text";
        },
        filteredChildren() {
            if (!this.node || !this.node.children) return [];

            return this.node.children.filter(child => {
                return child.type !== 'task' && child.type !== 'question';
            });
        },
        hasExpandableChildren() {
            return this.filteredChildren.length > 0;
        },
        canViewNode() {
            return !this.node.viewerRights || this.node.viewerRights.canView !== false;
        },
        showMarkList() {
            return this.status === 'in_progress' && this.node.type !== 'area' && this.node.viewerRights && this.node.viewerRights.canPostScore
        }
    },

    created() {
        // canView может отсутствовать, но если нет viewerRights — по умолчанию показываем
        if (this.node && !this.node.viewerRights) this.node.viewerRights = {};
        if (this.node && typeof this.node.canView === "undefined") {
        this.node.canView = true;
        if (this.node.viewerRights && typeof this.node.viewerRights.canView !== "undefined") {
            this.node.canView = !!this.node.viewerRights.canView;
        }
        }
    },

    watch: {
        'node.score'(val) {
            // при обновлении оценки
            this.$forceUpdate();
        }
    },

    methods: {
        selectNode() {
            this.$emit("selectNode", this.node);

            if (!this.hasExpandableChildren) {
                this.isOpen = false;
                return;
            }

            this.isOpen = !this.isOpen;
        },
        onSelectMark(score) {
            this.$emit("selectMark", score);
        },
        onClickMark() {
            // если это не task/question и есть дети — подтверждаем
            const hasChildren = this.node && this.node.children && this.node.children.length;
            const isLeaf = this.node && (this.node.type === "task" || this.node.type === "question");

            if (!isLeaf && hasChildren) {
                this.$emit("requestMark", { node: this.node, mode: "confirm" });
            } else {
                this.$emit("requestMark", { node: this.node, mode: "direct" });
            }
        },

        getTitleByType(type) {
            const map = {
                area: "Область знаний",
                competency: "Компетенция",
                theme: "Тема",
                subtopic: "Подтема"
            };
            return map[type] || "";
        },

    }
};
</script>
<style scoped>
    .interview-title {
        min-height: auto;
    }
    .interview-title span {
        font-size: 10px;
        text-transform: uppercase;
        font-weight: 500;
        border-bottom: none;
    }
    .mark-block {
        position: absolute;
        bottom: 15px;
        padding: 0 !important;
    }
    .interview-acordeon-head {
        padding-bottom: 30px;
    }
    .mr-41 {
        margin-right: 41px !important;
    }
</style>